(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/widget-area/helpers/handlebars-helpers.js') >= 0) return;  svs.modules.push('/components/core/widget-area/helpers/handlebars-helpers.js'); 
(function() {
  'use strict';

  const getWidgetDiv = (body, crm = {}) => {
    var ret = '<div class="widget"';
    for (var key of Object.keys(crm)) {
      ret += ' data-crm-' + key + '="' + crm[key] + '"';
    }
    ret += '>';
    if (body) {
      ret += body;
    }
    ret += '</div>';
    return ret;
  };

  function registerHelper(hbs) {
    hbs.registerHelper('widgetArea', function(options) {
      var isServerside = typeof exports === 'object';
      if (!options.hash || !options.hash.name) {
        throw new Error('Parameter "name" not supplied for widgetArea helper');
      }

      var html = '';
      var content =
          options.data && options.data.root && options.data.root.content;

      content = content || this.content;

      if (content && isServerside) {
        var log;
        var path = require('path');
        var trinidad = require(path.join(__dirname, '..', '..', '..', '..', 'core')).core;
        var contents = content[options.hash.name];

        log = trinidad.logger('trinidad:widgets');
        if (contents && contents.length > 0) {
          for (var i = 0, length = contents.length; i < length; i++) {
            contents[i].data = contents[i].data || {};
            if (contents[i].template) {
              options.data.root.currentWidget = contents[i].data;
              options.data.root.currentWidget.index = i;
              try {
                html += getWidgetDiv(contents[i].template(options.data.root), contents[i].data.crm);
              } catch (err) {
                html += getWidgetDiv();
                log.error('WidgetArea helper failed to create widget: ' +
                    options.hash.name +
                    ', with error:' +
                    err.message);
              }
              delete options.data.root.currentWidget;
            } else {
              html += getWidgetDiv();
            }
          }
          return new hbs.SafeString('<div class="widget-area' +
              (options.hash.class ? ' ' + options.hash.class : '') +
              '" id="' +
              options.hash.name +
              '">' +
              html +
              '</div>');
        }
        return '';
      } else if (!isServerside) {
        if (svs.widgets.data[options.hash.name]) {
          var widgets = svs.widgets.data[options.hash.name];
          if (Array.isArray(widgets)) {
            if (svs.core.widget_area.hasWidgetPartials(widgets)) {
              setTimeout(
                svs.core.widget_area.widgetAttach(options.hash.name, true),
                0
              );
              return new Handlebars.SafeString('<div class="widget-area' +
                  (options.hash.class ? ' ' + options.hash.class : '') +
                  '" id="' +
                  options.hash.name +
                  '">' +
                  svs.core.widget_area.widgetPartialsToHTML(widgets) +
                  '</div>');
            }
            $(svs.core.widget_area.widgetAttach(options.hash.name, false));
            return new Handlebars.SafeString('<div class="widget-area' +
                (options.hash.class ? ' ' + options.hash.class : '') +
                '" id="' +
                options.hash.name +
                '"></div>');
          }
        }
      }
    });
  }

  if (typeof exports === 'object') {
    module.exports = registerHelper;
  } else {
    registerHelper(Handlebars);
  }
})();

 })(window);